var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogFormVisible,
        width: "660px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: _vm.close
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("确 定")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "editForm",
          attrs: { "label-width": "120px", model: _vm.form, rules: _vm.rules }
        },
        [
          _c(
            "vab-query-form",
            [
              _c(
                "vab-query-form-top-panel",
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "中国海关编码:", prop: "hsCode" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "20",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.hsCode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "hsCode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "大类:", prop: "category" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.category,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "category",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.category"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "章节:", prop: "chapter" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.chapter,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "chapter",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.chapter"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "商品名称:", prop: "items" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.items,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "items",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.items"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "商品描述:", prop: "description" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "description",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.description"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        label: "中国申报要素:",
                        prop: "declarationElementsCn"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.declarationElementsCn,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "declarationElementsCn",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.declarationElementsCn"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "监管条件:", prop: "regulatoryCondition" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.regulatoryCondition,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "regulatoryCondition",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.regulatoryCondition"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "普通税率:", prop: "generalRates" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.generalRates,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "generalRates",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.generalRates"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "优惠税率:", prop: "preferentialRates" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.preferentialRates,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "preferentialRates",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.preferentialRates"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "出口税率:", prop: "exitRates" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.exitRates,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "exitRates",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.exitRates"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "消费税率:", prop: "consumeRates" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.consumeRates,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "consumeRates",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.consumeRates"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "增值税率:", prop: "vatRates" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.vatRates,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "vatRates",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.vatRates"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "第一法定单位:", prop: "firstLegalUnit" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.firstLegalUnit,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "firstLegalUnit",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.firstLegalUnit"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "第二法定单位:", prop: "secondLegalUnit" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.secondLegalUnit,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "secondLegalUnit",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.secondLegalUnit"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { label: "检验检疫:", prop: "inspection" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "500",
                          placeholder: "请输入",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.form.inspection,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "inspection",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.inspection"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }